import { render } from "./DialogValidateFormula.vue?vue&type=template&id=5bf1d55d"
import script from "./DialogValidateFormula.vue?vue&type=script&lang=js"
export * from "./DialogValidateFormula.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__